export const COUNTRY_DETAILS_MAP = {
  EC: {
    "priority": 1,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "TZ Child Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 180,
        "eta_post_checkout_unit": "days",
        "eta_post_appointment_duration": 20,
        "eta_post_appointment_unit": "days",
        "isApplicationFees": true,
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 0,
        "service_charge": 50,
        "visa_fees_agent": 100,
        "service_charge_agent": 150,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": true,
        "child_visa_fees": 200,
        "child_visa_fees_agent": 300,
        "zoneA": 10,
        "zoneB": 30,
        "zoneC": 50,
        "_id": "68b55dccf8980ed3b0c490db"
      }
    ],
    "country_name": "Ecuador",
    "code": "EC",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/TZ/1756716254982-Ohioo.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68b55dccf8980ed3b0c490da",
    "name": "Ecuador",
    "price": 50,
    "price_agent": 100,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/TZ/1756716253812-iStock-Norway.jpg",
      "https://cdn.tryvisa.com/Photos/TZ/1756716292110-HAnoi.jpg"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "successRate": 83,
    "__v": 0
  },
  "FINLND": {
    "priority": 1,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Finland Single Entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 4,
        "eta_post_checkout_unit": "days",
        "eta_post_appointment_duration": 10,
        "eta_post_appointment_unit": "days",
        "isApplicationFees": true,
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 200,
        "service_charge": 10,
        "visa_fees_agent": 100,
        "service_charge_agent": 20,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 200,
        "zoneB": 300,
        "zoneC": 400,
        "_id": "68b55010f8980ed3b0c457d8"
      },
      {
        "id": 1,
        "process_name": "Finland Child Package",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 4,
        "eta_post_checkout_unit": "days",
        "eta_post_appointment_duration": 5,
        "eta_post_appointment_unit": "days",
        "isApplicationFees": true,
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 300,
        "service_charge": 50,
        "visa_fees_agent": 400,
        "service_charge_agent": 100,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": true,
        "child_visa_fees": 300,
        "child_visa_fees_agent": 400,
        "zoneA": 100,
        "zoneB": 200,
        "zoneC": 300,
        "_id": "68b55010f8980ed3b0c457d9"
      }
    ],
    "country_name": "Finland",
    "code": "FINLND",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/FIN/1756706719804-13-best-fjords-in-Norway-to-see-and-visit-2.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68b55010f8980ed3b0c457d7",
    "name": "Finland",
    "price": 100,
    "price_agent": 200,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/FIN/1756706721018-georgia.jpg",
      "https://cdn.tryvisa.com/Photos/FIN/1756706825273-Phillipines.jpg"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "successRate": 100,
    "__v": 0
  },
  AE: {
    "priority": 1,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "UAE 30 days Single Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "eta_post_appointment_duration": 2,
        "eta_post_appointment_unit": "days",
        "isApplicationFees": true,
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 6500,
        "service_charge": 500,
        "visa_fees_agent": 6500,
        "service_charge_agent": 200,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "isChildPackage": true,
        "child_visa_fees": 1250,
        "child_visa_fees_agent": 1250,
        "_id": "68679be343b67b5d90d71cf7"
      },
      {
        "id": 1,
        "process_name": "UAE 30 days Single Entry E-Visa (Express)",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 1,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 11500,
        "service_charge": 500,
        "visa_fees_agent": 11500,
        "service_charge_agent": 200,
        "speed": "express",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679be343b67b5d90d71cf8"
      },
      {
        "id": 2,
        "process_name": "UAE 30 days multiple entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 4,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 11000,
        "service_charge": 500,
        "visa_fees_agent": 11000,
        "service_charge_agent": 200,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687a3f4139dbe8750892d563"
      },
      {
        "id": 3,
        "process_name": "UAE 60 days multiple entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 4,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "60 days",
        "entry_validity": "60 days",
        "visa_fees": 16000,
        "service_charge": 500,
        "visa_fees_agent": 16000,
        "service_charge_agent": 200,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687f6359310d4a59431a967b"
      },
      {
        "id": 4,
        "process_name": "UAE 48 hours transit",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 3,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "2 days",
        "entry_validity": "30 days",
        "visa_fees": 2000,
        "service_charge": 500,
        "visa_fees_agent": 2000,
        "service_charge_agent": 200,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687f6359310d4a59431a967c"
      },
      {
        "id": 5,
        "process_name": "UAE 96 hours transit",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 3,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "4 days",
        "entry_validity": "30 days",
        "visa_fees": 4000,
        "service_charge": 500,
        "visa_fees_agent": 4000,
        "service_charge_agent": 200,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687f6359310d4a59431a967d"
      }
    ],
    "country_name": "United Arab Emirates",
    "code": "AE",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/AE/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679be343b67b5d90d71cf6",
    "name": "United Arab Emirates",
    "price": 6500,
    "price_agent": 6500,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/AE/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/AE/3.webp?v=2"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 94
  },
  SG: {
    "priority": 2,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Singapore 30 days Single Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 10,
        "eta_post_checkout_unit": "days",
        "eta_post_appointment_duration": 5,
        "eta_post_appointment_unit": "days",
        "isApplicationFees": true,
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 3800,
        "service_charge": 1000,
        "visa_fees_agent": 3800,
        "service_charge_agent": 500,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "zoneA": 500,
        "zoneB": 600,
        "zoneC": 700,
        "_id": "68679be443b67b5d90d71cfc"
      }
    ],
    "country_name": "Singapore",
    "code": "SG",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/SG/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679be443b67b5d90d71cfb",
    "name": "Singapore",
    "price": 3800,
    "price_agent": 3800,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/SG/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/SG/3.webp?v=2"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 90
  },
  TH: {
    "priority": 3,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Thailand 15 days Single Entry Free Visa",
        "supported": true,
        "message": "Visa Free till 11 November 2024",
        "eta_post_checkout_duration": 1,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "15 days",
        "entry_validity": "30 days",
        "visa_fees": 1,
        "service_charge": 99,
        "visa_fees_agent": 1,
        "service_charge_agent": 99,
        "speed": "regular",
        "visa_type": "Tourist",
        "_id": "68679be543b67b5d90d71d00"
      },
      {
        "id": 1,
        "process_name": "Thailand 60 days Multiple Entry Free Visa",
        "supported": true,
        "message": "Visa Free till 11 November 2024",
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "60 days",
        "entry_validity": "180 days",
        "visa_fees": 2500,
        "service_charge": 1000,
        "visa_fees_agent": 2500,
        "service_charge_agent": 200,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679be543b67b5d90d71d01"
      },
      {
        "id": 2,
        "process_name": "Thailand 60 days Business Single Entry Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "60 days",
        "entry_validity": "180 days",
        "visa_fees": 5000,
        "service_charge": 1000,
        "visa_fees_agent": 5000,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "6881edca310d4a59431b223a"
      }
    ],
    "country_name": "Thailand",
    "code": "TH",
    "hero_image_url": "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8VGhhaWxhbmR8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679be543b67b5d90d71cff",
    "name": "Thailand",
    "price": 99,
    "price_agent": 99,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8VGhhaWxhbmR8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8VGhhaWxhbmR8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_free",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 98
  },
  BD: {
    "priority": 4,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Bangladesh 30 days Single Entry Stamp Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 7,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 2000,
        "service_charge": 550,
        "visa_fees_agent": 2000,
        "service_charge_agent": 550,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": false,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "68679be743b67b5d90d71d0a"
      },
      {
        "id": 1,
        "process_name": "Bangladesh Business 6 Month Multiple Entry Stamp Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 7,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 4500,
        "service_charge": 1000,
        "visa_fees_agent": 4500,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": false,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "68820a9b310d4a59431b4005"
      },
      {
        "id": 2,
        "process_name": "Bangladesh Business Bangladesh- 1 Year Multiple Entry Stamp Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 7,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 6500,
        "service_charge": 1000,
        "visa_fees_agent": 6500,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": false,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "68820a9b310d4a59431b4006"
      },
      {
        "id": 3,
        "process_name": "Bangladesh Business 6 Month Multiple Entry Stamp Visa Express",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 3,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 6500,
        "service_charge": 1000,
        "visa_fees_agent": 6500,
        "service_charge_agent": 300,
        "speed": "express",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": false,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "68820a9b310d4a59431b4007"
      },
      {
        "id": 4,
        "process_name": "Bangladesh Business Bangladesh- 1 Year Multiple Entry Stamp Visa Express",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 3,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 8500,
        "service_charge": 1000,
        "visa_fees_agent": 8500,
        "service_charge_agent": 300,
        "speed": "express",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": false,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "68820a9b310d4a59431b4008"
      }
    ],
    "country_name": "Bangladesh",
    "code": "BD",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/BD/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679be743b67b5d90d71d09",
    "name": "Bangladesh",
    "price": 2000,
    "price_agent": 2000,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/BD/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/BD/3.webp?v=2"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 95
  },
  OM: {
    "priority": 4,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Oman 10 days Single Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 4,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "10 days",
        "entry_validity": "90 days",
        "visa_fees": 1800,
        "service_charge": 500,
        "visa_fees_agent": 1800,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679be643b67b5d90d71d05"
      },
      {
        "id": 1,
        "process_name": "Oman 30 days Multiple Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 4,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 5000,
        "service_charge": 500,
        "visa_fees_agent": 5000,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679be643b67b5d90d71d06"
      }
    ],
    "country_name": "Oman",
    "code": "OM",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/OM/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679be643b67b5d90d71d04",
    "name": "Oman",
    "price": 1800,
    "price_agent": 1800,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/OM/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/OM/3.webp?v=2"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 95
  },
  KR: {
    "priority": 5,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "South Korea 30 days Single Entry Sticker-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 55,
        "eta_post_checkout_unit": "days",
        "eta_post_appointment_duration": 55,
        "eta_post_appointment_unit": "days",
        "isApplicationFees": true,
        "entry_type": "Single Entry",
        "entry_length_stay": "30 Days",
        "entry_validity": "90 days",
        "visa_fees": 5380,
        "service_charge": 1000,
        "visa_fees_agent": 5380,
        "service_charge_agent": 500,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 500,
        "zoneB": 600,
        "zoneC": 700,
        "_id": "68b55b58f8980ed3b0c487da"
      },
      {
        "id": 1,
        "process_name": "South Korea 30 days Business Single Entry Sticker-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "eta_post_appointment_duration": 100,
        "eta_post_appointment_unit": "days",
        "isApplicationFees": true,
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 5500,
        "service_charge": 1000,
        "visa_fees_agent": 5500,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "68b55b58f8980ed3b0c487db"
      }
    ],
    "country_name": "South Korea",
    "code": "KR",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/KR/1753646013730-business-5475283_640.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bf443b67b5d90d71d47",
    "name": "South Korea",
    "price": 5380,
    "price_agent": 5380,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/KR/1753646037606-2.jpg",
      "https://cdn.tryvisa.com/Photos/KR/1753646037609-istockphoto-1137568153-612x612.jpg"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 91
  },
  BH: {
    "priority": 6,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Bahrain 14 days Single Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "14  days",
        "entry_validity": "60 days",
        "visa_fees": 2290,
        "service_charge": 1000,
        "visa_fees_agent": 2290,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679be843b67b5d90d71d0e"
      },
      {
        "id": 1,
        "process_name": "Bahrain 90 days Multiple Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 3890,
        "service_charge": 1000,
        "visa_fees_agent": 3890,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687f73a8310d4a59431a9dcf"
      },
      {
        "id": 2,
        "process_name": "Bahrain 14 days Business Single Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 2290,
        "service_charge": 1000,
        "visa_fees_agent": 2290,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "68820465310d4a59431b3a89"
      },
      {
        "id": 3,
        "process_name": "Bahrain 90 days Business Multiple Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 3890,
        "service_charge": 1000,
        "visa_fees_agent": 3890,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "68820465310d4a59431b3a8a"
      }
    ],
    "country_name": "Bahrain",
    "code": "BH",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/BH/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679be843b67b5d90d71d0d",
    "name": "Bahrain",
    "price": 2290,
    "price_agent": 2290,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/BH/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/BH/3.webp?v=2"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 98
  },
  VN: {
    "priority": 6,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Vietnam 30 days Single Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 7,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "30 days",
        "visa_fees": 2550,
        "service_charge": 1000,
        "visa_fees_agent": 2550,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679bf043b67b5d90d71d35"
      },
      {
        "id": 1,
        "process_name": "Vietnam 30 days Multiple Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 7,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "30 days",
        "visa_fees": 4500,
        "service_charge": 1000,
        "visa_fees_agent": 4500,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679bf043b67b5d90d71d36"
      },
      {
        "id": 2,
        "process_name": "Vietnam 30 days Single Entry Business E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 7,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 2550,
        "service_charge": 1000,
        "visa_fees_agent": 2550,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689c7659bbe886337fa84d32"
      },
      {
        "id": 3,
        "process_name": "Vietnam 30 days Business Multiple Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 7,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 4500,
        "service_charge": 1000,
        "visa_fees_agent": 4500,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689c7659bbe886337fa84d33"
      }
    ],
    "country_name": "Vietnam",
    "code": "VN",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/VN/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bf043b67b5d90d71d34",
    "name": "Vietnam",
    "price": 2550,
    "price_agent": 2550,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/VN/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/VN/3.webp?v=2"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 98
  },
  MY: {
    "priority": 7,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Malaysia 30 days Single Entry Free Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 4,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "30 days",
        "visa_fees": 200,
        "service_charge": 300,
        "visa_fees_agent": 200,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679be943b67b5d90d71d13"
      }
    ],
    "country_name": "Malaysia",
    "code": "MY",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/MY/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679be943b67b5d90d71d12",
    "name": "Malaysia",
    "price": 200,
    "price_agent": 200,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/MY/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/MY/3.webp?v=2"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 92
  },
  LK: {
    "priority": 8,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Sri Lanka 30 days Single Entry ETA",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 1,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "180 days",
        "visa_fees": 1,
        "service_charge": 99,
        "visa_fees_agent": 1,
        "service_charge_agent": 99,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "On Arrival",
        "_id": "68679bea43b67b5d90d71d17"
      },
      {
        "id": 1,
        "process_name": "Sri Lanka 30 days Business Multiple Entry ETA",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 4,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 4750,
        "service_charge": 1000,
        "visa_fees_agent": 4750,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "6881fef2310d4a59431b359e"
      }
    ],
    "country_name": "Sri Lanka",
    "code": "LK",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/LK/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bea43b67b5d90d71d16",
    "name": "Sri Lanka",
    "price": 1,
    "price_agent": 1,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/LK/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/LK/3.webp?v=2"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 98
  },
  ID: {
    "priority": 9,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Indonesia 30 days Single Entry Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 6,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 3300,
        "service_charge": 400,
        "visa_fees_agent": 3300,
        "service_charge_agent": 200,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679bf643b67b5d90d71d56"
      }
    ],
    "country_name": "Indonesia",
    "code": "ID",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/ID/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bf643b67b5d90d71d55",
    "name": "Indonesia",
    "price": 3300,
    "price_agent": 3300,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/ID/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/ID/3.webp?v=2"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 85
  },
  KE: {
    "priority": 9,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Kenya 30 days Single Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 2600,
        "service_charge": 1000,
        "visa_fees_agent": 2600,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679bea43b67b5d90d71d1b"
      },
      {
        "id": 1,
        "process_name": "Kenya 30 days Business Single Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 2600,
        "service_charge": 1000,
        "visa_fees_agent": 2600,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "6882024e310d4a59431b38f4"
      }
    ],
    "country_name": "Kenya",
    "code": "KE",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/KE/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bea43b67b5d90d71d1a",
    "name": "Kenya",
    "price": 2600,
    "price_agent": 2600,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/KE/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/KE/3.webp?v=2"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 85
  },
  AU: {
    "priority": 10,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Australia 90 daysMultiple Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 29,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "90 Days",
        "entry_validity": "3 years",
        "visa_fees": 13500,
        "service_charge": 500,
        "visa_fees_agent": 13500,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679bf743b67b5d90d71d5a"
      }
    ],
    "country_name": "Australia",
    "code": "AU",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/AU/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bf743b67b5d90d71d59",
    "name": "Australia",
    "price": 13500,
    "price_agent": 13500,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/AU/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/AU/3.webp?v=2"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 81
  },
  US: {
    "priority": 10,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "US 10 Year Multiple Entry Stamp Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 180,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "180 days",
        "entry_validity": "10 Year",
        "visa_fees": 17280,
        "service_charge": 1000,
        "visa_fees_agent": 17280,
        "service_charge_agent": 500,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "68679c3143b67b5d90d71e30"
      }
    ],
    "country_name": "United States",
    "code": "US",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/US/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c3143b67b5d90d71e2f",
    "name": "United States",
    "price": 17280,
    "price_agent": 17280,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/US/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/US/3.webp?v=2"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 72
  },
  CN: {
    "priority": 11,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "China 30 days Single Entry Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 7,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 5000,
        "service_charge": 1000,
        "visa_fees_agent": 5000,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "zoneA": 500,
        "zoneB": 600,
        "zoneC": 700,
        "_id": "68679bf543b67b5d90d71d52"
      },
      {
        "id": 1,
        "process_name": "China 30 days Double Entry Sticker  Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 7,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 6500,
        "service_charge": 1000,
        "visa_fees_agent": 6500,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 500,
        "zoneB": 600,
        "zoneC": 700,
        "_id": "689aeebabbe886337fa7dee6"
      },
      {
        "id": 2,
        "process_name": "China 30 days Single Entry Sticker Visa (Express)",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 4,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 9000,
        "service_charge": 1000,
        "visa_fees_agent": 9000,
        "service_charge_agent": 300,
        "speed": "express",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 500,
        "zoneB": 600,
        "zoneC": 700,
        "_id": "689aeebabbe886337fa7dee7"
      },
      {
        "id": 3,
        "process_name": "China 30 days Double Entry Sticker Visa (Express)",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 4,
        "eta_post_checkout_unit": "days",
        "entry_type": "Double Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 10000,
        "service_charge": 1000,
        "visa_fees_agent": 10000,
        "service_charge_agent": 300,
        "speed": "express",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 500,
        "zoneB": 600,
        "zoneC": 700,
        "_id": "689aeebabbe886337fa7dee8"
      },
      {
        "id": 4,
        "process_name": "China 30 days Business Single Entry Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 7,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 5000,
        "service_charge": 1000,
        "visa_fees_agent": 5000,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 500,
        "zoneB": 600,
        "zoneC": 700,
        "_id": "689c6584bbe886337fa83b92"
      },
      {
        "id": 5,
        "process_name": "China 30 days Business Double Entry Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 7,
        "eta_post_checkout_unit": "days",
        "entry_type": "Double Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 6500,
        "service_charge": 1000,
        "visa_fees_agent": 6500,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 500,
        "zoneB": 600,
        "zoneC": 700,
        "_id": "689c6584bbe886337fa83b93"
      },
      {
        "id": 6,
        "process_name": "China 30 days Single Entry Sticker Visa (Express)",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 4,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 9000,
        "service_charge": 1000,
        "visa_fees_agent": 9000,
        "service_charge_agent": 300,
        "speed": "express",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 500,
        "zoneB": 600,
        "zoneC": 700,
        "_id": "689c6584bbe886337fa83b94"
      },
      {
        "id": 7,
        "process_name": "China 30 days Double Entry Sticker Visa (Express)",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 4,
        "eta_post_checkout_unit": "days",
        "entry_type": "Double Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 10000,
        "service_charge": 1000,
        "visa_fees_agent": 10000,
        "service_charge_agent": 300,
        "speed": "express",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 500,
        "zoneB": 600,
        "zoneC": 700,
        "_id": "689c6584bbe886337fa83b95"
      }
    ],
    "country_name": "China",
    "code": "CN",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/CN/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bf543b67b5d90d71d51",
    "name": "China",
    "price": 5000,
    "price_agent": 5000,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/CN/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/CN/3.webp?v=2"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 85
  },
  HK: {
    "priority": 11,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Hong Kong 14 days Single Entry PAR",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 1,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "14 days",
        "entry_validity": "180 days",
        "visa_fees": 200,
        "service_charge": 300,
        "visa_fees_agent": 200,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Visa_on_arrival",
        "visa_process": "E-Visa",
        "_id": "68679bee43b67b5d90d71d2c"
      }
    ],
    "country_name": "Hong Kong SAR China",
    "code": "HK",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/HK/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bee43b67b5d90d71d2b",
    "name": "Hong Kong SAR China",
    "price": 200,
    "price_agent": 200,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/HK/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/HK/3.webp?v=2"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 85
  },
  QA: {
    "priority": 11,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Qatar 30 days Single Entry E- Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 7,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 5500,
        "service_charge": 0,
        "visa_fees_agent": 5500,
        "service_charge_agent": 0,
        "speed": "regular",
        "visa_type": "Evisa",
        "visa_process": "E-Visa",
        "_id": "68679c0a43b67b5d90d71da1"
      }
    ],
    "country_name": "Qatar",
    "code": "QA",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/QA/1.webp?v=2",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c0a43b67b5d90d71da0",
    "name": "Qatar",
    "price": 5500,
    "price_agent": 5500,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/QA/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/QA/3.webp?v=2"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 96
  },
  RU: {
    "priority": 11,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Russia 16 days Single Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 8,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "16 days",
        "entry_validity": "60 days",
        "visa_fees": 5500,
        "service_charge": 1000,
        "visa_fees_agent": 5500,
        "service_charge_agent": 500,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679bec43b67b5d90d71d23"
      }
    ],
    "country_name": "Russia",
    "code": "RU",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/RU/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bec43b67b5d90d71d22",
    "name": "Russia",
    "price": 5500,
    "price_agent": 5500,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/RU/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/RU/3.webp?v=2"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 96
  },
  EG: {
    "priority": 12,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Egypt 30 days Single Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 2148,
        "service_charge": 1000,
        "visa_fees_agent": 2148,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679bed43b67b5d90d71d27"
      },
      {
        "id": 1,
        "process_name": "Egypt 30 days Multiple Entry E- Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30  days",
        "entry_validity": "90 days",
        "visa_fees": 5155,
        "service_charge": 1000,
        "visa_fees_agent": 5155,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679bed43b67b5d90d71d28"
      }
    ],
    "country_name": "Egypt",
    "code": "EG",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/EG/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bed43b67b5d90d71d26",
    "name": "Egypt",
    "price": 2148,
    "price_agent": 2148,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/EG/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/EG/3.webp?v=2"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 93
  },
  ZA: {
    "priority": 12,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "South Africa 30 days Single Entry Sticker visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 15,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "180 days",
        "visa_fees": 2301,
        "service_charge": 1000,
        "visa_fees_agent": 2301,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "zoneA": 500,
        "zoneB": 600,
        "zoneC": 700,
        "_id": "68679beb43b67b5d90d71d1f"
      },
      {
        "id": 1,
        "process_name": "South Africa 30 days Single Entry Business Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 15,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 2301,
        "service_charge": 1000,
        "visa_fees_agent": 2301,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 500,
        "zoneB": 600,
        "zoneC": 700,
        "_id": "689c705dbbe886337fa8489a"
      }
    ],
    "country_name": "South Africa",
    "code": "ZA",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/ZA/1755081486754-1bf85165652999.5afbcfef0c140.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679beb43b67b5d90d71d1e",
    "name": "South Africa",
    "price": 2301,
    "price_agent": 2301,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/ZA/1755081492293-170918153733-04-johannesburg-restricted.jpg",
      "https://cdn.tryvisa.com/Photos/ZA/1755081492294-TAL-cape-town-lead-image-CAPETOWNSA0225-62934faa0ba84971901ce90b2eeaab56.jpg"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 92
  },
  AZ: {
    "priority": 14,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Azerbaijan 30 days Single Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 3000,
        "service_charge": 400,
        "visa_fees_agent": 3000,
        "service_charge_agent": 200,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679bef43b67b5d90d71d30"
      },
      {
        "id": 1,
        "process_name": "Azerbaijan 30 days Single Entry E-Visa (Express)",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 1,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 5174,
        "service_charge": 400,
        "visa_fees_agent": 5174,
        "service_charge_agent": 200,
        "speed": "express",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679bef43b67b5d90d71d31"
      },
      {
        "id": 2,
        "process_name": "Azerbaijan 30 days Single Entry Business",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 2,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 3000,
        "service_charge": 400,
        "visa_fees_agent": 3000,
        "service_charge_agent": 200,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "6880c6fa310d4a59431adf59"
      },
      {
        "id": 3,
        "process_name": "Azerbaijan 30 days Single Entry Business Express",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 1,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 5174,
        "service_charge": 400,
        "visa_fees_agent": 5174,
        "service_charge_agent": 200,
        "speed": "express",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "6880c85b310d4a59431ae18f"
      }
    ],
    "country_name": "Azerbaijan",
    "code": "AZ",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/AZ/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bef43b67b5d90d71d2f",
    "name": "Azerbaijan",
    "price": 3000,
    "price_agent": 3000,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/AZ/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/AZ/3.webp?v=2"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 98
  },
  UZ: {
    "priority": 15,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Uzbekistan 30 days Single Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 7,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 1730,
        "service_charge": 1000,
        "visa_fees_agent": 1730,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679c0e43b67b5d90d71daf"
      },
      {
        "id": 1,
        "process_name": "Uzbekistan 30 days Single Business Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 7,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 1730,
        "service_charge": 1000,
        "visa_fees_agent": 1730,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "6880d43a310d4a59431aeb71"
      }
    ],
    "country_name": "Uzbekistan",
    "code": "UZ",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/UZ/1753251000844-pexels-axp-photography-500641970-19439186.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c0e43b67b5d90d71dae",
    "name": "Uzbekistan",
    "price": 1730,
    "price_agent": 1730,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/UZ/1753251000098-pexels-axp-photography-500641970-19439197.jpg",
      "https://cdn.tryvisa.com/Photos/UZ/1753251000099-pexels-axp-photography-500641970-19473631.jpg"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 99
  },
  TR: {
    "priority": 16,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Turkey 30 days E-Visa (U.K., USA, Schengen visa holders)",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 2,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "180 days",
        "visa_fees": 4500,
        "service_charge": 1000,
        "visa_fees_agent": 4500,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679bf143b67b5d90d71d3a"
      },
      {
        "id": 1,
        "process_name": "Turkey 30 days Sticker-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 10,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 18000,
        "service_charge": 1000,
        "visa_fees_agent": 18000,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "zoneA": 500,
        "zoneB": 600,
        "zoneC": 700,
        "_id": "68679bf143b67b5d90d71d3b"
      },
      {
        "id": 2,
        "process_name": "Turkey 30 days Sticker-Visa (Express)",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 10,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "180 days",
        "visa_fees": 20000,
        "service_charge": 1000,
        "visa_fees_agent": 20000,
        "service_charge_agent": 300,
        "speed": "express",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": false,
        "zoneA": 500,
        "zoneB": 600,
        "zoneC": 700,
        "_id": "68679bf143b67b5d90d71d3c"
      },
      {
        "id": 3,
        "process_name": "Turkey Business 6 month Multiple Entry Sticker Visa ",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 15,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "180 days",
        "visa_fees": 30000,
        "service_charge": 1000,
        "visa_fees_agent": 30000,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 500,
        "zoneB": 600,
        "zoneC": 700,
        "_id": "689c672fbbe886337fa83f5c"
      },
      {
        "id": 4,
        "process_name": "Turkey Business 12 month Multiple Entry Sticker Visa ",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 15,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "365 days",
        "visa_fees": 32500,
        "service_charge": 1000,
        "visa_fees_agent": 32500,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 500,
        "zoneB": 600,
        "zoneC": 700,
        "_id": "689c672fbbe886337fa83f5d"
      }
    ],
    "country_name": "Turkey",
    "code": "TR",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/TR/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bf143b67b5d90d71d39",
    "name": "Turkey",
    "price": 18000,
    "price_agent": 18000,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/TR/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/TR/3.webp?v=2"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 96
  },
  PH: {
    "priority": 17,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Philippines 90 days Single Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 12,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 5720,
        "service_charge": 1000,
        "visa_fees_agent": 5720,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679bf243b67b5d90d71d40"
      },
      {
        "id": 1,
        "process_name": "Philippines 180 days Multiple  Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 21,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "60 days",
        "entry_validity": "180 days",
        "visa_fees": 9240,
        "service_charge": 1000,
        "visa_fees_agent": 9240,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687f7fb8310d4a59431aa47e"
      },
      {
        "id": 2,
        "process_name": "Philippines 1 year Multiple  Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 21,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "120 days",
        "entry_validity": "1 year",
        "visa_fees": 12760,
        "service_charge": 1000,
        "visa_fees_agent": 12760,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687f7fb8310d4a59431aa47f"
      },
      {
        "id": 3,
        "process_name": "Philippines 90 days Business Single Entry E-Visa ",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 12,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 5720,
        "service_charge": 1000,
        "visa_fees_agent": 5720,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "68820eba310d4a59431b42f9"
      },
      {
        "id": 4,
        "process_name": "Philippines 180 days Business Multiple Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 21,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 9240,
        "service_charge": 1000,
        "visa_fees_agent": 9240,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "68820eba310d4a59431b42fa"
      },
      {
        "id": 5,
        "process_name": "Philippines 1 year Business Multiple Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 21,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 12760,
        "service_charge": 1000,
        "visa_fees_agent": 12760,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "68820eba310d4a59431b42fb"
      }
    ],
    "country_name": "Philippines",
    "code": "PH",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/PH/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bf243b67b5d90d71d3f",
    "name": "Philippines",
    "price": 5720,
    "price_agent": 5720,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/PH/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/PH/3.webp?v=2"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 91
  },
  JP: {
    "priority": 18,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Japan 30 days Single Entry Stamp-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry / Multiple",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 2000,
        "service_charge": 1000,
        "visa_fees_agent": 2000,
        "service_charge_agent": 500,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Stamp",
        "_id": "68679bf343b67b5d90d71d44"
      }
    ],
    "country_name": "Japan",
    "code": "JP",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/JP/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bf343b67b5d90d71d43",
    "name": "Japan",
    "price": 2000,
    "price_agent": 2000,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/JP/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/JP/3.webp?v=2"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 95
  },
  BR: {
    "priority": 20,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Brazil 30 days Single Entry Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 15,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 8000,
        "service_charge": 1000,
        "visa_fees_agent": 8000,
        "service_charge_agent": 500,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "_id": "68679bf443b67b5d90d71d4e"
      }
    ],
    "country_name": "Brazil",
    "code": "BR",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/BR/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bf443b67b5d90d71d4d",
    "name": "Brazil",
    "price": 8000,
    "price_agent": 8000,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/BR/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/BR/3.webp?v=2"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 91
  },
  MG: {
    "priority": 24,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Madagascar 15 days Single Entry Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 7,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "15 Days",
        "entry_validity": "90 days",
        "visa_fees": 865,
        "service_charge": 1000,
        "visa_fees_agent": 865,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679b5894588ba72c74b4df"
      },
      {
        "id": 1,
        "process_name": "Madagascar 30 days Single Entry Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 7,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 3200,
        "service_charge": 1000,
        "visa_fees_agent": 3200,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679b5894588ba72c74b4e0"
      },
      {
        "id": 2,
        "process_name": "Madagascar 60 days Single Entry Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 7,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "90 days",
        "visa_fees": 3890,
        "service_charge": 1000,
        "visa_fees_agent": 3890,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679b5894588ba72c74b4e1"
      }
    ],
    "country_name": "Madagascar",
    "code": "MG",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/MG/1753185773164-istockphoto-468053398-612x612.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c0743b67b5d90d71d91",
    "name": "Madagascar",
    "price": 865,
    "price_agent": 865,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/MG/1753185785194-Isalo-National-Park-sunrise.jpg",
      "https://cdn.tryvisa.com/Photos/MG/1753185785194-istockphoto-840859134-612x612.jpg"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 100
  },
  SA: {
    "priority": 25,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Saudi Arabia 1 year Multiple Entry Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 12,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple",
        "entry_length_stay": "90 days",
        "entry_validity": "1 year",
        "visa_fees": 20500,
        "service_charge": 500,
        "visa_fees_agent": 20500,
        "service_charge_agent": 500,
        "speed": "regular",
        "visa_type": "E-Visa",
        "_id": "68679c0c43b67b5d90d71da8"
      }
    ],
    "country_name": "Saudi Arabia",
    "code": "SA",
    "hero_image_url": "https://images.unsplash.com/photo-1565552645632-d725f8bfc19a?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8U2F1ZGklMjBBcmFiaWF8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c0c43b67b5d90d71da7",
    "name": "Saudi Arabia",
    "price": 20500,
    "price_agent": 20500,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1565552645632-d725f8bfc19a?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8U2F1ZGklMjBBcmFiaWF8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1565552645632-d725f8bfc19a?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8U2F1ZGklMjBBcmFiaWF8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 93
  },
  AT: {
    "priority": 50,
    "isSchengen": true,
    "packages": [
      {
        "id": 0,
        "process_name": "Austria 90 Days Single Entry Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11500,
        "service_charge": 1500,
        "visa_fees_agent": 11500,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689af8a2bbe886337fa7e421"
      },
      {
        "id": 1,
        "process_name": "Austria 90 Days Single Business Entry Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11500,
        "service_charge": 1500,
        "visa_fees_agent": 11500,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689c787abbe886337fa84fdd"
      }
    ],
    "country_name": "Austria",
    "code": "AT",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/AT/1755159206469-austria.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c1043b67b5d90d71db8",
    "name": "Austria",
    "price": 11500,
    "price_agent": 11500,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/AT/1755084854281-Christmas-Market-Vienna-Austria.jpg",
      "https://cdn.tryvisa.com/Photos/AT/1755084861919-18.jpg"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 84
  },
  AL: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Albania",
    "code": "AL",
    "hero_image_url": "https://images.unsplash.com/photo-1557313501-341d9d6fd40f?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8QWxiYW5pYXxlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c0f43b67b5d90d71db2",
    "name": "Albania",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1557313501-341d9d6fd40f?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8QWxiYW5pYXxlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1557313501-341d9d6fd40f?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8QWxiYW5pYXxlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  DZ: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Algeria",
    "code": "DZ",
    "hero_image_url": "https://images.unsplash.com/photo-1549145177-238518f1ec1a?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8QWxnZXJpYXxlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c1943b67b5d90d71dd7",
    "name": "Algeria",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1549145177-238518f1ec1a?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8QWxnZXJpYXxlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1549145177-238518f1ec1a?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8QWxnZXJpYXxlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  AO: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Angola",
    "code": "AO",
    "hero_image_url": "https://images.unsplash.com/photo-1520709087497-0749666fe1d2?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8QW5nb2xhfGVufDB8fDB8fHww",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bfb43b67b5d90d71d69",
    "name": "Angola",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1520709087497-0749666fe1d2?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8QW5nb2xhfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1520709087497-0749666fe1d2?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8QW5nb2xhfGVufDB8fDB8fHww"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  AG: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Antigua & Barbuda",
    "code": "AG",
    "hero_image_url": "https://images.unsplash.com/photo-1582300857444-5ddd87c86797?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8QW50aWd1YSUyMCUyNiUyMEJhcmJ1ZGF8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bf943b67b5d90d71d63",
    "name": "Antigua & Barbuda",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1582300857444-5ddd87c86797?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8QW50aWd1YSUyMCUyNiUyMEJhcmJ1ZGF8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1582300857444-5ddd87c86797?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8QW50aWd1YSUyMCUyNiUyMEJhcmJ1ZGF8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  AR: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Argentina",
    "code": "AR",
    "hero_image_url": "https://images.unsplash.com/photo-1589909202802-8f4aadce1849?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8QXJnZW50aW5hfGVufDB8fDB8fHww",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c0f43b67b5d90d71db5",
    "name": "Argentina",
    "price": 750,
    "price_agent": 750,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1589909202802-8f4aadce1849?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8QXJnZW50aW5hfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1589909202802-8f4aadce1849?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8QXJnZW50aW5hfGVufDB8fDB8fHww"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 90
  },
  AM: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Armenia 21 days single entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 4,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "21  days",
        "entry_validity": "60 days",
        "visa_fees": 517,
        "service_charge": 1000,
        "visa_fees_agent": 517,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687f8d8b310d4a59431aa858"
      },
      {
        "id": 1,
        "process_name": "Armenia 120  days single entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 4,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "120 days",
        "entry_validity": "180 days",
        "visa_fees": 2589,
        "service_charge": 1000,
        "visa_fees_agent": 2589,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687f8d8b310d4a59431aa859"
      },
      {
        "id": 2,
        "process_name": "Armenia 21 days single entry Business E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 4,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 517,
        "service_charge": 1000,
        "visa_fees_agent": 517,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "6880d2e4310d4a59431aea14"
      },
      {
        "id": 3,
        "process_name": "Armenia 120 days single entry Business E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 4,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "120 days",
        "entry_validity": "180 days",
        "visa_fees": 2590,
        "service_charge": 1000,
        "visa_fees_agent": 2590,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "6880d2e4310d4a59431aea15"
      }
    ],
    "country_name": "Armenia",
    "code": "AM",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/AM/1753272946411-pexels-julia-volk-5273004.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bfa43b67b5d90d71d66",
    "name": "Armenia",
    "price": 517,
    "price_agent": 517,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/AM/1753272956209-pexels-artem-makarov-289670876-30454809.jpg",
      "https://cdn.tryvisa.com/Photos/AM/1753272956210-pexels-julia-volk-5272958.jpg"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 98
  },
  BB: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Barbados",
    "code": "BB",
    "hero_image_url": "https://images.unsplash.com/photo-1626023523650-f9fe5e85cacc?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8QmFyYmFkb3N8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c4843b67b5d90d71e83",
    "name": "Barbados",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1626023523650-f9fe5e85cacc?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8QmFyYmFkb3N8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1626023523650-f9fe5e85cacc?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8QmFyYmFkb3N8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_free",
    "visa_free_message": "",
    "__v": 0
  },
  BE: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [
      {
        "id": 0,
        "process_name": "Belgium 90 Days Single Entry Sticker- visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 90,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11500,
        "service_charge": 1500,
        "visa_fees_agent": 11500,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689b0660bbe886337fa7e539"
      },
      {
        "id": 1,
        "process_name": "Belgium 90 Days Business Single Entry Sticker- visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11500,
        "service_charge": 1500,
        "visa_fees_agent": 11500,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689c79b4bbe886337fa8513d"
      }
    ],
    "country_name": "Belgium",
    "code": "BE",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/BE/1755160222593-photo-1547057951-61fcf322bb1e.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c1143b67b5d90d71dbb",
    "name": "Belgium",
    "price": 11500,
    "price_agent": 11500,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/BE/1755085195067-Antwerp_Main.jpg",
      "https://cdn.tryvisa.com/Photos/BE/1755085200578-belgium-top-rated-attractions-places-to-visit-ghents-canals.jpg"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 85
  },
  BJ: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Benin",
    "code": "BJ",
    "hero_image_url": "https://images.unsplash.com/photo-1600241005059-71de13374958?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8QmVuaW58ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bfd43b67b5d90d71d6f",
    "name": "Benin",
    "price": 7750,
    "price_agent": 7750,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1600241005059-71de13374958?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8QmVuaW58ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1600241005059-71de13374958?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8QmVuaW58ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  BT: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Bhutan 30 days single Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 3500,
        "service_charge": 1000,
        "visa_fees_agent": 3500,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679c5043b67b5d90d71e9f"
      }
    ],
    "country_name": "Bhutan",
    "code": "BT",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/BT/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c5043b67b5d90d71e9e",
    "name": "Bhutan",
    "price": 3500,
    "price_agent": 3500,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/BT/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/BT/3.webp?v=2"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 90
  },
  BW: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Botswana",
    "code": "BW",
    "hero_image_url": "https://images.unsplash.com/photo-1591005383946-16532ba69aee?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Qm90c3dhbmF8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bfe43b67b5d90d71d72",
    "name": "Botswana",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1591005383946-16532ba69aee?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Qm90c3dhbmF8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1591005383946-16532ba69aee?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Qm90c3dhbmF8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  VG: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "British Virgin Islands",
    "code": "VG",
    "hero_image_url": "https://images.unsplash.com/photo-1622581646489-6066b5c697e9?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8QnJpdGlzaCUyMFZpcmdpbiUyMElzbGFuZHN8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c4a43b67b5d90d71e8c",
    "name": "British Virgin Islands",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1622581646489-6066b5c697e9?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8QnJpdGlzaCUyMFZpcmdpbiUyMElzbGFuZHN8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1622581646489-6066b5c697e9?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8QnJpdGlzaCUyMFZpcmdpbiUyMElzbGFuZHN8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_free",
    "visa_free_message": "",
    "__v": 0
  },
  BF: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Burkina Faso",
    "code": "BF",
    "hero_image_url": "https://images.unsplash.com/photo-1645531635989-2102135314c3?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8QnVya2luYSUyMEZhc298ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bfc43b67b5d90d71d6c",
    "name": "Burkina Faso",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1645531635989-2102135314c3?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8QnVya2luYSUyMEZhc298ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1645531635989-2102135314c3?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8QnVya2luYSUyMEZhc298ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  KH: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Cambodia 30 days single entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 3,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 2588,
        "service_charge": 1000,
        "visa_fees_agent": 2588,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687f8f18310d4a59431aa91a"
      },
      {
        "id": 1,
        "process_name": "Cambodia 30 days Business single entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 3,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 2588,
        "service_charge": 1000,
        "visa_fees_agent": 2588,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "6880ca74310d4a59431ae3d7"
      }
    ],
    "country_name": "Cambodia",
    "code": "KH",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/KH/1753270684777-bayon-temple-with-giant-stone-faces-angkor-wat-siem-reap-cambodia.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bf943b67b5d90d71d60",
    "name": "Cambodia",
    "price": 2587,
    "price_agent": 2588,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/KH/1753270811115-asia-woman-thai-dress-traditiona.jpg",
      "https://cdn.tryvisa.com/Photos/KH/1753270811116-pexels-julia-volk-5769435.jpg"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 98
  },
  CA: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "180 days Multiple Entry sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 45,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "180 days",
        "entry_validity": "10 years",
        "visa_fees": 12870,
        "service_charge": 2000,
        "visa_fees_agent": 12870,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "68679c1243b67b5d90d71dbf"
      }
    ],
    "country_name": "Canada",
    "code": "CA",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/CA/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c1243b67b5d90d71dbe",
    "name": "Canada",
    "price": 12870,
    "price_agent": 12870,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/CA/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/CA/3.webp?v=2"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 68
  },
  CV: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Cape Verde",
    "code": "CV",
    "hero_image_url": "https://images.unsplash.com/photo-1592761855671-33347cb2f7bb?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8Q2FwZSUyMFZlcmRlfGVufDB8fDB8fHww",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c3b43b67b5d90d71e56",
    "name": "Cape Verde",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1592761855671-33347cb2f7bb?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8Q2FwZSUyMFZlcmRlfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1592761855671-33347cb2f7bb?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8Q2FwZSUyMFZlcmRlfGVufDB8fDB8fHww"
    ],
    "sticker_visa": false,
    "purpose": "visa_on_arrival",
    "visa_free_message": "",
    "__v": 0
  },
  CL: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Chile",
    "code": "CL",
    "hero_image_url": "https://images.unsplash.com/photo-1478827387698-1527781a4887?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Q2hpbGV8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c1443b67b5d90d71dc5",
    "name": "Chile",
    "price": 14278,
    "price_agent": 14278,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1478827387698-1527781a4887?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Q2hpbGV8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1478827387698-1527781a4887?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Q2hpbGV8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  CO: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Colombia",
    "code": "CO",
    "hero_image_url": "https://images.unsplash.com/photo-1576018753502-1a55b66cc44a?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8Q29sb21iaWF8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c1543b67b5d90d71dc8",
    "name": "Colombia",
    "price": 12250,
    "price_agent": 12250,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1576018753502-1a55b66cc44a?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8Q29sb21iaWF8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1576018753502-1a55b66cc44a?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8Q29sb21iaWF8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  KM: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Comoros",
    "code": "KM",
    "hero_image_url": "https://images.unsplash.com/photo-1581412218131-a2b5634c074d?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Q29tb3Jvc3xlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c3c43b67b5d90d71e59",
    "name": "Comoros",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1581412218131-a2b5634c074d?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Q29tb3Jvc3xlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1581412218131-a2b5634c074d?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Q29tb3Jvc3xlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_on_arrival",
    "visa_free_message": "",
    "__v": 0
  },
  CK: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Cook Islands",
    "code": "CK",
    "hero_image_url": "https://images.unsplash.com/photo-1604988162322-d5d678a1d993?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Q29vayUyMElzbGFuZHN8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c4443b67b5d90d71e77",
    "name": "Cook Islands",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1604988162322-d5d678a1d993?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Q29vayUyMElzbGFuZHN8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1604988162322-d5d678a1d993?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Q29vayUyMElzbGFuZHN8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_on_arrival",
    "visa_free_message": "",
    "__v": 0
  },
  CR: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Costa Rica",
    "code": "CR",
    "hero_image_url": "https://images.unsplash.com/photo-1536708880921-03a9306ec47d?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Q29zdGElMjBSaWNhfGVufDB8fDB8fHww",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c1643b67b5d90d71dcb",
    "name": "Costa Rica",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1536708880921-03a9306ec47d?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Q29zdGElMjBSaWNhfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1536708880921-03a9306ec47d?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Q29zdGElMjBSaWNhfGVufDB8fDB8fHww"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  HR: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [
      {
        "id": 0,
        "process_name": "Croatia 90 Days Single Entry Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 60,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 10500,
        "service_charge": 1500,
        "visa_fees_agent": 10500,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689b0adcbbe886337fa7e670"
      },
      {
        "id": 1,
        "process_name": "Croatia 90 Days Business Single Entry Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 10500,
        "service_charge": 1500,
        "visa_fees_agent": 10500,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689c7b62bbe886337fa852d3"
      }
    ],
    "country_name": "Croatia",
    "code": "HR",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/HR/1755085622715-caption.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c3943b67b5d90d71e50",
    "name": "Croatia",
    "price": 10500,
    "price_agent": 10500,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/HR/1755085628099-Best-places-to-visit-in-Croatia-for-couples11.png",
      "https://cdn.tryvisa.com/Photos/HR/1755085628100-croatia-dubrovnik-old-town-4.jpg"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 88
  },
  CU: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Cuba E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 15,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 Days",
        "entry_validity": "90 Days",
        "visa_fees": 5000,
        "service_charge": 1000,
        "visa_fees_agent": 5000,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689b0c14bbe886337fa7e707"
      }
    ],
    "country_name": "Cuba",
    "code": "CU",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/CU/1754994417156-istockphoto-1194346148-612x612.png",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c1643b67b5d90d71dce",
    "name": "Cuba",
    "price": 5000,
    "price_agent": 5000,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/CU/1754994436335-havana-7844664_1280.jpg",
      "https://cdn.tryvisa.com/Photos/CU/1754994436336-La-Habana.jpg"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 100
  },
  CY: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Cyprus 90 Days Single Entry Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 10000,
        "service_charge": 1000,
        "visa_fees_agent": 10000,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689b0d46bbe886337fa7e75f"
      },
      {
        "id": 1,
        "process_name": "Cyprus 90 Days Business Single Entry Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 10000,
        "service_charge": 1000,
        "visa_fees_agent": 10000,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689c7dc4bbe886337fa857e6"
      }
    ],
    "country_name": "Cyprus",
    "code": "CY",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/CY/1755166807715-ekdromi-kipro-me-karnavali-lemesou-beach.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bff43b67b5d90d71d75",
    "name": "Cyprus",
    "price": 10000,
    "price_agent": 10000,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/CY/1755086223197-cyprus-archway-turquoise-sea-1024x683.jpg",
      "https://cdn.tryvisa.com/Photos/CY/1755086223198-istockphoto-519498404-612x612.jpg"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 89
  },
  CZ: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [],
    "country_name": "Czechia",
    "code": "CZ",
    "hero_image_url": "https://images.unsplash.com/photo-1589312893179-38d2eb60655d?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Q3plY2hpYXxlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c1743b67b5d90d71dd1",
    "name": "Czechia",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1589312893179-38d2eb60655d?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Q3plY2hpYXxlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1589312893179-38d2eb60655d?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Q3plY2hpYXxlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 82
  },
  DK: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [
      {
        "id": 0,
        "process_name": "Denmark 90 Days Single Entry Sticker visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11500,
        "service_charge": 1500,
        "visa_fees_agent": 11500,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689b0fcfbbe886337fa7eb60"
      },
      {
        "id": 1,
        "process_name": "Denmark 90 Days Business Single Entry Sticker visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11500,
        "service_charge": 1500,
        "visa_fees_agent": 11500,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689c7e87bbe886337fa85e84"
      }
    ],
    "country_name": "Denmark",
    "code": "DK",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/DK/1755166082212-a5b7b710339afc5362f9e16b1baf0821.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c3643b67b5d90d71e42",
    "name": "Denmark",
    "price": 11500,
    "price_agent": 11500,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/DK/1755091138893-223176_Skovtrnet.jpg",
      "https://cdn.tryvisa.com/Photos/DK/1755091138896-Amalienborg-Palace-top.jpg"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 81
  },
  DM: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Dominica",
    "code": "DM",
    "hero_image_url": "https://images.unsplash.com/photo-1499598896209-c62806b9ae75?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8RG9taW5pY2F8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c4d43b67b5d90d71e95",
    "name": "Dominica",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1499598896209-c62806b9ae75?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8RG9taW5pY2F8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1499598896209-c62806b9ae75?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8RG9taW5pY2F8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_free",
    "visa_free_message": "",
    "__v": 0
  },
  SV: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "El Salvador",
    "code": "SV",
    "hero_image_url": "https://images.unsplash.com/photo-1618074951760-70364e5dcedb?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8RWwlMjBTYWx2YWRvcnxlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c4f43b67b5d90d71e9b",
    "name": "El Salvador",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1618074951760-70364e5dcedb?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8RWwlMjBTYWx2YWRvcnxlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1618074951760-70364e5dcedb?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8RWwlMjBTYWx2YWRvcnxlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_on_arrival",
    "visa_free_message": "",
    "__v": 0
  },
  GQ: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Equatorial Guinea",
    "code": "GQ",
    "hero_image_url": "https://images.unsplash.com/photo-1509840825703-6af73fa6c128?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8RXF1YXRvcmlhbCUyMEd1aW5lYXxlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c0243b67b5d90d71d7e",
    "name": "Equatorial Guinea",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1509840825703-6af73fa6c128?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8RXF1YXRvcmlhbCUyMEd1aW5lYXxlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1509840825703-6af73fa6c128?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8RXF1YXRvcmlhbCUyMEd1aW5lYXxlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  EE: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [],
    "country_name": "Estonia",
    "code": "EE",
    "hero_image_url": "https://images.unsplash.com/photo-1627727240079-2d3c29bf8a23?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8RXN0b25pYXxlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c1a43b67b5d90d71dda",
    "name": "Estonia",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1627727240079-2d3c29bf8a23?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8RXN0b25pYXxlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1627727240079-2d3c29bf8a23?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8RXN0b25pYXxlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  ET: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Ethiopia Tourist 30 Days Single Entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 5360,
        "service_charge": 1000,
        "visa_fees_agent": 5360,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687f725764508a5348a12f26"
      },
      {
        "id": 1,
        "process_name": "Ethiopia Tourist 90 Days Multiple Entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 13130,
        "service_charge": 1000,
        "visa_fees_agent": 13130,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687f725764508a5348a12f27"
      },
      {
        "id": 2,
        "process_name": "Ethiopia Tourist 30 Days Business Single Entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 5350,
        "service_charge": 1000,
        "visa_fees_agent": 5350,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "6881e156310d4a59431b1cfe"
      }
    ],
    "country_name": "Ethiopia",
    "code": "ET",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/ET/1753182797438-pexels-lan-yao-324969-6742951.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c0043b67b5d90d71d78",
    "name": "Ethiopia",
    "price": 5360,
    "price_agent": 5359,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/ET/1753182802081-pexels-fanuel-33019023.jpg",
      "https://cdn.tryvisa.com/Photos/ET/1753182802081-pexels-lan-yao-324969-6742986.jpg"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 98
  },
  FJ: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Fiji",
    "code": "FJ",
    "hero_image_url": "https://images.unsplash.com/photo-1530736822234-c8562cb0a710?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8RmlqaXxlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c5443b67b5d90d71eae",
    "name": "Fiji",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1530736822234-c8562cb0a710?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8RmlqaXxlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1530736822234-c8562cb0a710?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8RmlqaXxlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_on_arrival",
    "visa_free_message": "",
    "__v": 0
  },
  FI: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [
      {
        "id": 0,
        "process_name": "Finland 90 days Single Entry Sticker  Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11000,
        "service_charge": 1500,
        "visa_fees_agent": 11000,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "68679c1c43b67b5d90d71de1"
      },
      {
        "id": 1,
        "process_name": "Finland 90 days Business Single Entry Sticker  Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11000,
        "service_charge": 1500,
        "visa_fees_agent": 11000,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689c9128bbe886337fa861bb"
      }
    ],
    "country_name": "Finland",
    "code": "FI",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/FI/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c1c43b67b5d90d71de0",
    "name": "Finland",
    "price": 11000,
    "price_agent": 11000,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/FI/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/FI/3.webp?v=2"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 79
  },
  FR: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [
      {
        "id": 0,
        "process_name": "France 90 days Single Entry Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11500,
        "service_charge": 1500,
        "visa_fees_agent": 11500,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "68679c1c43b67b5d90d71de5"
      },
      {
        "id": 1,
        "process_name": "France 90 days Business Single Entry Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11500,
        "service_charge": 1500,
        "visa_fees_agent": 11500,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689c9167bbe886337fa86303"
      }
    ],
    "country_name": "France",
    "code": "FR",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/FR/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c1c43b67b5d90d71de4",
    "name": "France",
    "price": 11500,
    "price_agent": 11500,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/FR/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/FR/3.webp?v=2"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 86
  },
  GE: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Georgia 30 Days Multiple Entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 6,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 2500,
        "service_charge": 1000,
        "visa_fees_agent": 2500,
        "service_charge_agent": 500,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687f70ad64508a5348a12a0c"
      },
      {
        "id": 1,
        "process_name": "Georgia 30 Days Business Multiple Entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 6,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 2500,
        "service_charge": 1000,
        "visa_fees_agent": 2500,
        "service_charge_agent": 500,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "6881df79310d4a59431b1950"
      }
    ],
    "country_name": "Georgia",
    "code": "GE",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/GE/1753182344613-pexels-kelly-1179532-19063147.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c1e43b67b5d90d71dec",
    "name": "Georgia",
    "price": 2000,
    "price_agent": 2000,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/GE/1753182350285-pexels-rudy-kirchner-278171-2804123.jpg",
      "https://cdn.tryvisa.com/Photos/GE/1753182350286-pexels-tomas-malik-793526-2990775.jpg"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 99
  },
  DE: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [
      {
        "id": 0,
        "process_name": "Germany 90 Days Single Entry Sticker visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11500,
        "service_charge": 1500,
        "visa_fees_agent": 11500,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689b130fbbe886337fa7eeed"
      },
      {
        "id": 1,
        "process_name": "Germany 90 Days Business Single Entry Sticker visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11500,
        "service_charge": 1500,
        "visa_fees_agent": 11500,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689c91ecbbe886337fa868d1"
      }
    ],
    "country_name": "Germany",
    "code": "DE",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/DE/1755166384820-1096211.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c1843b67b5d90d71dd4",
    "name": "Germany",
    "price": 11500,
    "price_agent": 11500,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/DE/1755091966079-223176_Skovtrnet.jpg",
      "https://cdn.tryvisa.com/Photos/DE/1755091966081-ccimage-shutterstock_400724206.jpg"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 88
  },
  GH: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Ghana 30 days Single Entry Stamp Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 12160,
        "service_charge": 500,
        "visa_fees_agent": 12160,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Stamp Visa",
        "_id": "68679c2043b67b5d90d71df0"
      }
    ],
    "country_name": "Ghana",
    "code": "GH",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/GH/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c2043b67b5d90d71def",
    "name": "Ghana",
    "price": 12160,
    "price_agent": 12160,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/GH/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/GH/3.webp?v=2"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 92
  },
  GR: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [
      {
        "id": 0,
        "process_name": "Greece 90 Days single Entry Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 12500,
        "service_charge": 1500,
        "visa_fees_agent": 12500,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689b14ebbbe886337fa7ef84"
      },
      {
        "id": 1,
        "process_name": "Greece 90 Days Business single Entry Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 12500,
        "service_charge": 1500,
        "visa_fees_agent": 12500,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689c96fcbbe886337fa86c5c"
      }
    ],
    "country_name": "Greece",
    "code": "GR",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/GR/1755159527475-Greece.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c2043b67b5d90d71df3",
    "name": "Greece",
    "price": 12500,
    "price_agent": 12500,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/GR/1755092592948-shutterstock-259025516_destinationMain_1531741184863.jpeg",
      "https://cdn.tryvisa.com/Photos/GR/1755092592952-top-attractions-in-greece-thessaloniki.jpg"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 88
  },
  GN: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Guinea",
    "code": "GN",
    "hero_image_url": "https://images.unsplash.com/photo-1615608178738-37d47d27c13d?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8R3VpbmVhfGVufDB8fDB8fHww",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c0143b67b5d90d71d7b",
    "name": "Guinea",
    "price": 7750,
    "price_agent": 7750,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1615608178738-37d47d27c13d?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8R3VpbmVhfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1615608178738-37d47d27c13d?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8R3VpbmVhfGVufDB8fDB8fHww"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  GW: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Guinea-Bissau",
    "code": "GW",
    "hero_image_url": "https://images.unsplash.com/photo-1509840825703-6af73fa6c128?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8R3VpbmVhJTIwQmlzc2F1fGVufDB8fDB8fHww",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c3e43b67b5d90d71e5f",
    "name": "Guinea-Bissau",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1509840825703-6af73fa6c128?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8R3VpbmVhJTIwQmlzc2F1fGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1509840825703-6af73fa6c128?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8R3VpbmVhJTIwQmlzc2F1fGVufDB8fDB8fHww"
    ],
    "sticker_visa": false,
    "purpose": "visa_on_arrival",
    "visa_free_message": "",
    "__v": 0
  },
  GY: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Guyana",
    "code": "GY",
    "hero_image_url": "https://images.unsplash.com/photo-1595793822823-054c2b603dc4?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8R3V5YW5hfGVufDB8fDB8fHww",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c0243b67b5d90d71d81",
    "name": "Guyana",
    "price": 1750,
    "price_agent": 1750,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1595793822823-054c2b603dc4?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8R3V5YW5hfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1595793822823-054c2b603dc4?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8R3V5YW5hfGVufDB8fDB8fHww"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  HT: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Haiti",
    "code": "HT",
    "hero_image_url": "https://images.unsplash.com/photo-1603767868273-d59d712c8188?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8SGFpdGl8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c4743b67b5d90d71e80",
    "name": "Haiti",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1603767868273-d59d712c8188?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8SGFpdGl8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1603767868273-d59d712c8188?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8SGFpdGl8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_free",
    "visa_free_message": "",
    "__v": 0
  },
  HU: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [
      {
        "id": 0,
        "process_name": "Hungary 90 Days Single Entry sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 10000,
        "service_charge": 1500,
        "visa_fees_agent": 10000,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689b1797bbe886337fa7f6b1"
      },
      {
        "id": 1,
        "process_name": "Hungary 90 Days Business Single Entry sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 10000,
        "service_charge": 1500,
        "visa_fees_agent": 10000,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689c97f8bbe886337fa86ded"
      }
    ],
    "country_name": "Hungary",
    "code": "HU",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/HU/1755166910308-a5b7b710339afc5362f9e16b1baf0821.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c2143b67b5d90d71df6",
    "name": "Hungary",
    "price": 10000,
    "price_agent": 10000,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/HU/1755094320320-Hungary.jpg",
      "https://cdn.tryvisa.com/Photos/HU/1755094320333-Untitled-design-81.jpg"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 93
  },
  IS: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [
      {
        "id": 0,
        "process_name": "Iceland 90 Days Single Entry Sticker- visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 12000,
        "service_charge": 1500,
        "visa_fees_agent": 12000,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "68679c3743b67b5d90d71e46"
      },
      {
        "id": 1,
        "process_name": "Iceland 90 Days Business Single Entry Sticker- visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 12000,
        "service_charge": 1500,
        "visa_fees_agent": 12000,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689c9d94bbe886337fa86fdf"
      }
    ],
    "country_name": "Iceland",
    "code": "IS",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/IS/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c3743b67b5d90d71e45",
    "name": "Iceland",
    "price": 12000,
    "price_agent": 12000,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/IS/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/IS/3.webp?v=2"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 86
  },
  IL: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Israel",
    "code": "IL",
    "hero_image_url": "https://images.unsplash.com/photo-1547483029-77784da27709?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8SXNyYWVsfGVufDB8fDB8fHww",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c2243b67b5d90d71df9",
    "name": "Israel",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1547483029-77784da27709?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8SXNyYWVsfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1547483029-77784da27709?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8SXNyYWVsfGVufDB8fDB8fHww"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 82
  },
  IT: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [
      {
        "id": 0,
        "process_name": "Italy 90 Days Single Entry Stamp Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 10000,
        "service_charge": 1500,
        "visa_fees_agent": 10000,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "68679c3843b67b5d90d71e4a"
      },
      {
        "id": 1,
        "process_name": "Italy 90 Days Business Single Entry Stamp Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 10000,
        "service_charge": 1500,
        "visa_fees_agent": 10000,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689c9dd6bbe886337fa87175"
      }
    ],
    "country_name": "Italy",
    "code": "IT",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/IT/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c3843b67b5d90d71e49",
    "name": "Italy",
    "price": 10000,
    "price_agent": 10000,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/IT/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/IT/3.webp?v=2"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 86
  },
  JM: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Jamaica",
    "code": "JM",
    "hero_image_url": "https://images.unsplash.com/photo-1605994543054-6ffbabbd8139?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8SmFtYWljYXxlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c4b43b67b5d90d71e8f",
    "name": "Jamaica",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1605994543054-6ffbabbd8139?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8SmFtYWljYXxlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1605994543054-6ffbabbd8139?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8SmFtYWljYXxlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_on_arrival",
    "visa_free_message": "",
    "__v": 0
  },
  JO: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Jordan 30 days Single Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 7,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 5050,
        "service_charge": 500,
        "visa_fees_agent": 5050,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679c0343b67b5d90d71d85"
      }
    ],
    "country_name": "Jordan",
    "code": "JO",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/JO/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c0343b67b5d90d71d84",
    "name": "Jordan",
    "price": 5050,
    "price_agent": 5050,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/JO/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/JO/3.webp?v=2"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 85
  },
  KW: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Kuwait",
    "code": "KW",
    "hero_image_url": "https://images.unsplash.com/photo-1558634742-56096b49522b?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8S3V3YWl0fGVufDB8fDB8fHww",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c0443b67b5d90d71d88",
    "name": "Kuwait",
    "price": 29250,
    "price_agent": 29250,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1558634742-56096b49522b?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8S3V3YWl0fGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1558634742-56096b49522b?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8S3V3YWl0fGVufDB8fDB8fHww"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 96
  },
  KG: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Kyrgyzstan 30 Day Single Entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 18,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 4444,
        "service_charge": 1000,
        "visa_fees_agent": 4445,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68808cb2310d4a59431ad68a"
      },
      {
        "id": 1,
        "process_name": "Kyrgyzstan 30 Day Multiple Entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 18,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 5334,
        "service_charge": 1000,
        "visa_fees_agent": 5335,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68808cb2310d4a59431ad68b"
      },
      {
        "id": 2,
        "process_name": "Kyrgyzstan 30 Day Single Entry Express",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 2,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 13350,
        "service_charge": 1000,
        "visa_fees_agent": 13350,
        "service_charge_agent": 300,
        "speed": "express",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68808cb2310d4a59431ad68c"
      },
      {
        "id": 3,
        "process_name": "Kyrgyzstan 30 Day Multiple Entry Express",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 2,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 16020,
        "service_charge": 1000,
        "visa_fees_agent": 16020,
        "service_charge_agent": 300,
        "speed": "express",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68808cb2310d4a59431ad68d"
      },
      {
        "id": 4,
        "process_name": "Kyrgyzstan 30 Day Business Single Entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 18,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 4445,
        "service_charge": 1000,
        "visa_fees_agent": 4445,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "688207a8310d4a59431b3e3c"
      },
      {
        "id": 5,
        "process_name": "Kyrgyzstan 30 Day Business Multiple Entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 18,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 5335,
        "service_charge": 1000,
        "visa_fees_agent": 5335,
        "service_charge_agent": 30,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "688207a8310d4a59431b3e3d"
      },
      {
        "id": 6,
        "process_name": "Kyrgyzstan 30 Day Business Single Entry Express",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 2,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 13350,
        "service_charge": 1000,
        "visa_fees_agent": 13350,
        "service_charge_agent": 300,
        "speed": "express",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "688207a8310d4a59431b3e3e"
      },
      {
        "id": 7,
        "process_name": "Kyrgyzstan 30 Day Business Multiple Entry Express",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 2,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 16020,
        "service_charge": 1000,
        "visa_fees_agent": 16020,
        "service_charge_agent": 300,
        "speed": "express",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "688207a8310d4a59431b3e3f"
      }
    ],
    "country_name": "Kyrgyzstan",
    "code": "KG",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/KG/1753254899961-Holy-Lake-Arslanbob-Kyrgyzstan.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c2343b67b5d90d71dfc",
    "name": "Kyrgyzstan",
    "price": 4445,
    "price_agent": 4445,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/KG/1753254904561-56RKX1694673997.jpg",
      "https://cdn.tryvisa.com/Photos/KG/1753254904562-1698645047_main.jpg"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 98
  },
  LA: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Laos 30 days single entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 4,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 4315,
        "service_charge": 1000,
        "visa_fees_agent": 4315,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687fabbe310d4a59431ab349"
      }
    ],
    "country_name": "Laos",
    "code": "LA",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/LA/1753271843592-pexels-seongwoo-yun-228507616-12060089.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c0543b67b5d90d71d8b",
    "name": "Laos",
    "price": 4315,
    "price_agent": 4315,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/LA/1753271849074-pexels-suraphat-924631.jpg",
      "https://cdn.tryvisa.com/Photos/LA/1753271849074-pexels-suraphat-947997.jpg"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 100
  },
  LV: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [
      {
        "id": 0,
        "process_name": "Latvia Tourist Sticker Visa ",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11000,
        "service_charge": 1500,
        "visa_fees_agent": 11000,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689b2db4bbe886337fa8290e"
      },
      {
        "id": 1,
        "process_name": "Latvia Business Sticker Visa ",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11000,
        "service_charge": 1500,
        "visa_fees_agent": 11000,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689ca9b5bbe886337fa8836c"
      }
    ],
    "country_name": "Latvia",
    "code": "LV",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/LV/1755166609112-a5b7b710339afc5362f9e16b1baf0821.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c2643b67b5d90d71e08",
    "name": "Latvia",
    "price": 11000,
    "price_agent": 11000,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/LV/1755097811699-makalu-pixabay-latvia-3725547_1920.jpeg",
      "https://cdn.tryvisa.com/Photos/LV/1755098140314-europe-latvia-riga-old-riga-wallpaper-preview.jpg"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 91
  },
  LB: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Lebanon",
    "code": "LB",
    "hero_image_url": "https://images.unsplash.com/photo-1496823407868-80f47c7453b5?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8TGViYW5vbnxlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c2443b67b5d90d71dff",
    "name": "Lebanon",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1496823407868-80f47c7453b5?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8TGViYW5vbnxlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1496823407868-80f47c7453b5?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8TGViYW5vbnxlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  LI: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [],
    "country_name": "Liechtenstein",
    "code": "LI",
    "hero_image_url": "https://images.unsplash.com/photo-1512424113276-fa9f6a112384?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8TGllY2h0ZW5zdGVpbnxlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c2543b67b5d90d71e02",
    "name": "Liechtenstein",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1512424113276-fa9f6a112384?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8TGllY2h0ZW5zdGVpbnxlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1512424113276-fa9f6a112384?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8TGllY2h0ZW5zdGVpbnxlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  LT: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [],
    "country_name": "Lithuania",
    "code": "LT",
    "hero_image_url": "https://images.unsplash.com/photo-1567023249914-7c83f04de30c?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8TGl0aHVhbmlhfGVufDB8fDB8fHww",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c2643b67b5d90d71e05",
    "name": "Lithuania",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1567023249914-7c83f04de30c?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8TGl0aHVhbmlhfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1567023249914-7c83f04de30c?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8TGl0aHVhbmlhfGVufDB8fDB8fHww"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  LU: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Luxembourg",
    "code": "LU",
    "hero_image_url": "https://images.unsplash.com/photo-1593449044719-ea9688bb8706?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8THV4ZW1ib3VyZ3xlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c3843b67b5d90d71e4d",
    "name": "Luxembourg",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1593449044719-ea9688bb8706?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8THV4ZW1ib3VyZ3xlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1593449044719-ea9688bb8706?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8THV4ZW1ib3VyZ3xlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  MW: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Malawi",
    "code": "MW",
    "hero_image_url": "https://images.unsplash.com/photo-1612286710224-dd9eb9d8349a?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8TWFsYXdpfGVufDB8fDB8fHww",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c3a43b67b5d90d71e53",
    "name": "Malawi",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1612286710224-dd9eb9d8349a?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8TWFsYXdpfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1612286710224-dd9eb9d8349a?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8TWFsYXdpfGVufDB8fDB8fHww"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  MV: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Maldives",
    "code": "MV",
    "hero_image_url": "https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8TWFsZGl2ZXN8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c3d43b67b5d90d71e5c",
    "name": "Maldives",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8TWFsZGl2ZXN8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1573843981267-be1999ff37cd?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8TWFsZGl2ZXN8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_free",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 98
  },
  MT: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [],
    "country_name": "Malta",
    "code": "MT",
    "hero_image_url": "https://images.unsplash.com/photo-1571856975545-119703c5225c?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8TWFsdGF8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c2743b67b5d90d71e0b",
    "name": "Malta",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1571856975545-119703c5225c?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8TWFsdGF8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1571856975545-119703c5225c?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8TWFsdGF8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  MH: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Marshall Islands",
    "code": "MH",
    "hero_image_url": "https://images.unsplash.com/photo-1553709724-ccfb0930663f?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8TWFyc2hhbGwlMjBJc2xhbmRzfGVufDB8fDB8fHww",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c3e43b67b5d90d71e62",
    "name": "Marshall Islands",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1553709724-ccfb0930663f?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8TWFyc2hhbGwlMjBJc2xhbmRzfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1553709724-ccfb0930663f?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8TWFyc2hhbGwlMjBJc2xhbmRzfGVufDB8fDB8fHww"
    ],
    "sticker_visa": false,
    "purpose": "visa_on_arrival",
    "visa_free_message": "",
    "__v": 0
  },
  MR: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Mauritania",
    "code": "MR",
    "hero_image_url": "https://images.unsplash.com/photo-1543318557-a11bce6e033a?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8TWF1cml0YW5pYXxlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c3f43b67b5d90d71e65",
    "name": "Mauritania",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1543318557-a11bce6e033a?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8TWF1cml0YW5pYXxlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1543318557-a11bce6e033a?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8TWF1cml0YW5pYXxlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_on_arrival",
    "visa_free_message": "",
    "__v": 0
  },
  MU: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Mauritius",
    "code": "MU",
    "hero_image_url": "https://images.unsplash.com/photo-1571147558584-8490ea37d7a9?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8TWF1cml0aXVzfGVufDB8fDB8fHww",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c5143b67b5d90d71ea5",
    "name": "Mauritius",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1571147558584-8490ea37d7a9?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8TWF1cml0aXVzfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1571147558584-8490ea37d7a9?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8TWF1cml0aXVzfGVufDB8fDB8fHww"
    ],
    "sticker_visa": false,
    "purpose": "visa_free",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 85
  },
  FM: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Micronesia",
    "code": "FM",
    "hero_image_url": "https://images.unsplash.com/photo-1553602924-f9b35269e68b?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fE1pY3JvbmVzaWF8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c4543b67b5d90d71e7a",
    "name": "Micronesia",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1553602924-f9b35269e68b?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fE1pY3JvbmVzaWF8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1553602924-f9b35269e68b?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fE1pY3JvbmVzaWF8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_free",
    "visa_free_message": "",
    "__v": 0
  },
  MD: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Moldova",
    "code": "MD",
    "hero_image_url": "https://images.unsplash.com/photo-1593340646418-af8bc7d03b2e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8TW9sZG92YXxlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c0643b67b5d90d71d8e",
    "name": "Moldova",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1593340646418-af8bc7d03b2e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8TW9sZG92YXxlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1593340646418-af8bc7d03b2e?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8TW9sZG92YXxlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  MN: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Mongolia",
    "code": "MN",
    "hero_image_url": "https://images.unsplash.com/photo-1595692732588-2e8a32b77911?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c0843b67b5d90d71d97",
    "name": "Mongolia",
    "price": 2200,
    "price_agent": 2200,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1595692732588-2e8a32b77911?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      "https://images.unsplash.com/photo-1595692732588-2e8a32b77911?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  MS: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Montserrat",
    "code": "MS",
    "hero_image_url": "https://images.unsplash.com/photo-1571037288111-a4d130100fd5?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8TW9udHNlcnJhdHxlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c4843b67b5d90d71e86",
    "name": "Montserrat",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1571037288111-a4d130100fd5?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8TW9udHNlcnJhdHxlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1571037288111-a4d130100fd5?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8TW9udHNlcnJhdHxlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_free",
    "visa_free_message": "",
    "__v": 0
  },
  MA: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Morocco 30 Days Single Entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "180 days",
        "visa_fees": 7390,
        "service_charge": 1000,
        "visa_fees_agent": 7390,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687f768f64508a5348a139f5"
      },
      {
        "id": 1,
        "process_name": "Morocco 30 Days Express Entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 1,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "180 days",
        "visa_fees": 10550,
        "service_charge": 1000,
        "visa_fees_agent": 10550,
        "service_charge_agent": 300,
        "speed": "express",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687f768f64508a5348a139f6"
      },
      {
        "id": 2,
        "process_name": "Morocco 30 Days Single Entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 4,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "90 days",
        "visa_fees": 6542,
        "service_charge": 1000,
        "visa_fees_agent": 6542,
        "service_charge_agent": 199,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "_id": "687f768f64508a5348a139f7"
      },
      {
        "id": 3,
        "process_name": "Morocco 30 Days Multiple Entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "90 days",
        "visa_fees": 11425,
        "service_charge": 1000,
        "visa_fees_agent": 11425,
        "service_charge_agent": 200,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "_id": "687f768f64508a5348a139f8"
      },
      {
        "id": 4,
        "process_name": "Morocco 30 Days Business Single Entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "60 days",
        "visa_fees": 6542,
        "service_charge": 1000,
        "visa_fees_agent": 6542,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "_id": "6881e49d310d4a59431b1ff3"
      },
      {
        "id": 5,
        "process_name": "Morocco 30 Days Business Multiple Entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 11425,
        "service_charge": 1000,
        "visa_fees_agent": 11425,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "_id": "6881e49d310d4a59431b1ff4"
      }
    ],
    "country_name": "Morocco",
    "code": "MA",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/MA/1753183927687-pexels-mographe-3581916.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679bf843b67b5d90d71d5d",
    "name": "Morocco",
    "price": 7390,
    "price_agent": 7390,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/MA/1753183934694-pexels-edwin-vossen-206618-640936.jpg",
      "https://cdn.tryvisa.com/Photos/MA/1753183934695-pexels-postiglioni-943510.jpg"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 94
  },
  MZ: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Mozambique",
    "code": "MZ",
    "hero_image_url": "https://images.unsplash.com/photo-1526998758291-f87c4c1a8fff?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8TW96YW1iaXF1ZXxlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c0943b67b5d90d71d9a",
    "name": "Mozambique",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1526998758291-f87c4c1a8fff?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8TW96YW1iaXF1ZXxlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1526998758291-f87c4c1a8fff?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8TW96YW1iaXF1ZXxlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  MM: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Myanmar 28 days single entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "28 days",
        "entry_validity": "60 days",
        "visa_fees": 4292,
        "service_charge": 1000,
        "visa_fees_agent": 4294,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687fad29310d4a59431ab3f4"
      },
      {
        "id": 1,
        "process_name": "Myanmar 28 days Business single entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 4294,
        "service_charge": 1000,
        "visa_fees_agent": 4294,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "6880cc01310d4a59431ae4f0"
      }
    ],
    "country_name": "Myanmar (Burma)",
    "code": "MM",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/MM/1753271216808-pexels-munzir-1936997-3560161.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c3343b67b5d90d71e36",
    "name": "Myanmar (Burma)",
    "price": 4294,
    "price_agent": 4294,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/MM/1753271221658-pexels-munzir-1936997-3560166.jpg",
      "https://cdn.tryvisa.com/Photos/MM/1753271221659-pexels-the-trvlr-2643896__1_.jpg"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 97
  },
  NP: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Nepal",
    "code": "NP",
    "hero_image_url": "https://images.unsplash.com/photo-1529733905113-027ed85d7e33?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8TmVwYWx8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c4e43b67b5d90d71e98",
    "name": "Nepal",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1529733905113-027ed85d7e33?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8TmVwYWx8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1529733905113-027ed85d7e33?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8TmVwYWx8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_free",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 99
  },
  NL: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [
      {
        "id": 0,
        "process_name": "Netherlands 90 days Single Entry Sticker Visas",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 45,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11000,
        "service_charge": 1500,
        "visa_fees_agent": 11000,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "68679c2843b67b5d90d71e0f"
      },
      {
        "id": 1,
        "process_name": "Netherlands 90 days Business Single Entry Sticker Visas",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11000,
        "service_charge": 1500,
        "visa_fees_agent": 11000,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689c9ee8bbe886337fa87322"
      }
    ],
    "country_name": "Netherlands",
    "code": "NL",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/NL/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c2843b67b5d90d71e0e",
    "name": "Netherlands",
    "price": 11000,
    "price_agent": 11000,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/NL/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/NL/3.webp?v=2"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 83
  },
  NZ: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "New Zealand 90 days Single Entry E-Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 27,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "1 years",
        "visa_fees": 24000,
        "service_charge": 2000,
        "visa_fees_agent": 24000,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "68679c2a43b67b5d90d71e17"
      }
    ],
    "country_name": "New Zealand",
    "code": "NZ",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/NZ/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c2a43b67b5d90d71e16",
    "name": "New Zealand",
    "price": 24000,
    "price_agent": 24000,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/NZ/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/NZ/3.webp?v=2"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 87
  },
  NG: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Nigeria",
    "code": "NG",
    "hero_image_url": "https://images.unsplash.com/photo-1569706971306-de5d78f6418e?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8TmlnZXJpYXxlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c3343b67b5d90d71e39",
    "name": "Nigeria",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1569706971306-de5d78f6418e?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8TmlnZXJpYXxlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1569706971306-de5d78f6418e?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8TmlnZXJpYXxlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 75
  },
  NU: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Niue",
    "code": "NU",
    "hero_image_url": "https://images.prismic.io/atlys/MjlkZTk3NDQtMjk5Yi00NWVmLWFlNGEtNzg2NTFiMWQwMTI0_c3013c67-6857-45bd-9ed0-a2b020fc69b6_nu1.jpg?auto=compress,format&rect=0,0,2000,2500&w=2000&h=2500",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c5343b67b5d90d71eab",
    "name": "Niue",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.prismic.io/atlys/MjlkZTk3NDQtMjk5Yi00NWVmLWFlNGEtNzg2NTFiMWQwMTI0_c3013c67-6857-45bd-9ed0-a2b020fc69b6_nu1.jpg?auto=compress,format&rect=0,0,2000,2500&w=2000&h=2500",
      "https://images.prismic.io/atlys/MjlkZTk3NDQtMjk5Yi00NWVmLWFlNGEtNzg2NTFiMWQwMTI0_c3013c67-6857-45bd-9ed0-a2b020fc69b6_nu1.jpg?auto=compress,format&rect=0,0,2000,2500&w=2000&h=2500"
    ],
    "sticker_visa": false,
    "purpose": "visa_free",
    "visa_free_message": "",
    "__v": 0
  },
  NO: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [
      {
        "id": 0,
        "process_name": "Norway 90 days Single Entry Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "90 days",
        "visa_fees": 10000,
        "service_charge": 1500,
        "visa_fees_agent": 10000,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "68679c2943b67b5d90d71e13"
      },
      {
        "id": 1,
        "process_name": "Norway 90 days Business Single Entry Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 10000,
        "service_charge": 1500,
        "visa_fees_agent": 10000,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689c9f2fbbe886337fa87439"
      }
    ],
    "country_name": "Norway",
    "code": "NO",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/NO/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c2943b67b5d90d71e12",
    "name": "Norway",
    "price": 10000,
    "price_agent": 10000,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/NO/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/NO/3.webp?v=2"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 90
  },
  PW: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Palau",
    "code": "PW",
    "hero_image_url": "https://images.unsplash.com/photo-1569806145835-1413fbfc1af4?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8UGFsYXV8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c4043b67b5d90d71e68",
    "name": "Palau",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1569806145835-1413fbfc1af4?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8UGFsYXV8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1569806145835-1413fbfc1af4?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8UGFsYXV8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_on_arrival",
    "visa_free_message": "",
    "__v": 0
  },
  PG: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Papua New Guinea",
    "code": "PG",
    "hero_image_url": "https://images.unsplash.com/photo-1613183919710-2ff7b3bec845?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8UGFwdWElMjBOZXclMjBHdWluZWF8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c0943b67b5d90d71d9d",
    "name": "Papua New Guinea",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1613183919710-2ff7b3bec845?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8UGFwdWElMjBOZXclMjBHdWluZWF8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1613183919710-2ff7b3bec845?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8UGFwdWElMjBOZXclMjBHdWluZWF8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  PL: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [
      {
        "id": 0,
        "process_name": "Poland Tourist Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 Days",
        "entry_validity": "180 Days",
        "visa_fees": 10500,
        "service_charge": 1500,
        "visa_fees_agent": 10500,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689b22fabbe886337fa80115"
      },
      {
        "id": 1,
        "process_name": "Poland Business Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 10500,
        "service_charge": 1500,
        "visa_fees_agent": 10500,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689cac7bbbe886337fa885ea"
      }
    ],
    "country_name": "Poland",
    "code": "PL",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/PL/1754997392768-1668515496.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c2b43b67b5d90d71e1a",
    "name": "Poland",
    "price": 10500,
    "price_agent": 10500,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/PL/1754997398986-poznan-poland-shutterstock_636613312_1d49394d08.jpeg",
      "https://cdn.tryvisa.com/Photos/PL/1754997408166-poland-best-places-to-visit-ojcow.jpg"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 91
  },
  PT: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [
      {
        "id": 0,
        "process_name": "Portugal Tourist Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 Days",
        "entry_validity": "180 days",
        "visa_fees": 12500,
        "service_charge": 1500,
        "visa_fees_agent": 12500,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689b1b1abbe886337fa7f84c"
      },
      {
        "id": 1,
        "process_name": "Portugal Business Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 12500,
        "service_charge": 1500,
        "visa_fees_agent": 12500,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689cacbcbbe886337fa886fb"
      }
    ],
    "country_name": "Portugal",
    "code": "PT",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/PT/1754995288835-SUP-Benagil.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c2c43b67b5d90d71e1d",
    "name": "Portugal",
    "price": 12500,
    "price_agent": 12500,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/PT/1754995299198-30ba2cff933727deca9f1824c96159d5.jpg",
      "https://cdn.tryvisa.com/Photos/PT/1754995299199-why-visit-portugal-sintra.jpg"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 90
  },
  RW: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Rwanda",
    "code": "RW",
    "hero_image_url": "https://images.unsplash.com/photo-1489640818597-89b1edc97db5?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8UndhbmRhfGVufDB8fDB8fHww",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c0b43b67b5d90d71da4",
    "name": "Rwanda",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1489640818597-89b1edc97db5?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8UndhbmRhfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1489640818597-89b1edc97db5?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8UndhbmRhfGVufDB8fDB8fHww"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  RE: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Réunion",
    "code": "RE",
    "hero_image_url": "https://images.unsplash.com/photo-1617972405994-b3932f05d83a?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cmV1bmlvbiUyMGlzbGFuZHxlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c4c43b67b5d90d71e92",
    "name": "Réunion",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1617972405994-b3932f05d83a?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cmV1bmlvbiUyMGlzbGFuZHxlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1617972405994-b3932f05d83a?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cmV1bmlvbiUyMGlzbGFuZHxlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_on_arrival",
    "visa_free_message": "",
    "__v": 0
  },
  WS: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Samoa",
    "code": "WS",
    "hero_image_url": "https://images.unsplash.com/photo-1625224588813-cc8d5055493f?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8U2Ftb2F8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c4243b67b5d90d71e6e",
    "name": "Samoa",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1625224588813-cc8d5055493f?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8U2Ftb2F8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1625224588813-cc8d5055493f?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8U2Ftb2F8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_on_arrival",
    "visa_free_message": "",
    "__v": 0
  },
  SN: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Senegal",
    "code": "SN",
    "hero_image_url": "https://images.unsplash.com/photo-1583495506658-50a3587f792e?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fFNlbmVnYWx8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c4643b67b5d90d71e7d",
    "name": "Senegal",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1583495506658-50a3587f792e?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fFNlbmVnYWx8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1583495506658-50a3587f792e?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTR8fFNlbmVnYWx8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_free",
    "visa_free_message": "",
    "__v": 0
  },
  SC: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Seychelles",
    "code": "SC",
    "hero_image_url": "https://images.unsplash.com/photo-1577353716826-9151912dcdd1?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8U2V5Y2hlbGxlc3xlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c4343b67b5d90d71e71",
    "name": "Seychelles",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1577353716826-9151912dcdd1?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8U2V5Y2hlbGxlc3xlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1577353716826-9151912dcdd1?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8U2V5Y2hlbGxlc3xlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_on_arrival",
    "visa_free_message": "",
    "__v": 0
  },
  SK: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [],
    "country_name": "Slovakia",
    "code": "SK",
    "hero_image_url": "https://images.unsplash.com/photo-1620283110809-3ff3adfe057b?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8U2xvdmFraWF8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c2f43b67b5d90d71e26",
    "name": "Slovakia",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1620283110809-3ff3adfe057b?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8U2xvdmFraWF8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1620283110809-3ff3adfe057b?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8U2xvdmFraWF8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  SI: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [],
    "country_name": "Slovenia",
    "code": "SI",
    "hero_image_url": "https://images.unsplash.com/photo-1534754359223-fab5b6eadfdf?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8U2xvdmVuaWF8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c2e43b67b5d90d71e23",
    "name": "Slovenia",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1534754359223-fab5b6eadfdf?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8U2xvdmVuaWF8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1534754359223-fab5b6eadfdf?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8U2xvdmVuaWF8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  SO: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Somalia",
    "code": "SO",
    "hero_image_url": "https://images.unsplash.com/photo-1603999540542-b8c65c6d3e89?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8U29tYWxpYXxlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c4343b67b5d90d71e74",
    "name": "Somalia",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1603999540542-b8c65c6d3e89?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8U29tYWxpYXxlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1603999540542-b8c65c6d3e89?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8U29tYWxpYXxlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_on_arrival",
    "visa_free_message": "",
    "__v": 0
  },
  ES: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [
      {
        "id": 0,
        "process_name": "Spain 90 Days Single Entry Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 10595,
        "service_charge": 1500,
        "visa_fees_agent": 10595,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689b2d71bbe886337fa82853"
      },
      {
        "id": 1,
        "process_name": "Spain 90 Days Business Single Entry Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11000,
        "service_charge": 1500,
        "visa_fees_agent": 11000,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689c9f70bbe886337fa8764f"
      }
    ],
    "country_name": "Spain",
    "code": "ES",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/ES/1755095313428-Barcelona.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c1b43b67b5d90d71ddd",
    "name": "Spain",
    "price": 10595,
    "price_agent": 10595,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/ES/1755095322084-Catedral-de-Santiago-Galicia-AdobeStock_397103563.jpg",
      "https://cdn.tryvisa.com/Photos/ES/1755095322085-Spain.jpg"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 88
  },
  KN: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "St. Kitts & Nevis",
    "code": "KN",
    "hero_image_url": "https://images.unsplash.com/photo-1639222819309-f5b6e4f5e60a?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8U3QuJTIwS2l0dHMlMjAlMjYlMjBOZXZpc3xlbnwwfHwwfHx8MA%3D%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c4943b67b5d90d71e89",
    "name": "St. Kitts & Nevis",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1639222819309-f5b6e4f5e60a?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8U3QuJTIwS2l0dHMlMjAlMjYlMjBOZXZpc3xlbnwwfHwwfHx8MA%3D%3D",
      "https://images.unsplash.com/photo-1639222819309-f5b6e4f5e60a?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8U3QuJTIwS2l0dHMlMjAlMjYlMjBOZXZpc3xlbnwwfHwwfHx8MA%3D%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_free",
    "visa_free_message": "",
    "__v": 0
  },
  LC: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "St. Lucia",
    "code": "LC",
    "hero_image_url": "https://images.unsplash.com/photo-1617280325974-f9c5721a4862?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8U3QuJTIwTHVjaWF8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c4143b67b5d90d71e6b",
    "name": "St. Lucia",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1617280325974-f9c5721a4862?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8U3QuJTIwTHVjaWF8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1617280325974-f9c5721a4862?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8U3QuJTIwTHVjaWF8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_on_arrival",
    "visa_free_message": "",
    "__v": 0
  },
  VC: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "St. Vincent & Grenadines",
    "code": "VC",
    "hero_image_url": "https://images.unsplash.com/photo-1625694100768-181ea98d028a?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8U3QuJTIwVmluY2VudCUyMCUyNiUyMEdyZW5hZGluZXN8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c5043b67b5d90d71ea2",
    "name": "St. Vincent & Grenadines",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1625694100768-181ea98d028a?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8U3QuJTIwVmluY2VudCUyMCUyNiUyMEdyZW5hZGluZXN8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1625694100768-181ea98d028a?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OXx8U3QuJTIwVmluY2VudCUyMCUyNiUyMEdyZW5hZGluZXN8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_free",
    "visa_free_message": "",
    "__v": 0
  },
  SE: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [
      {
        "id": 0,
        "process_name": "Sweden 90 Days Single Entry Sticker visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11000,
        "service_charge": 1500,
        "visa_fees_agent": 11000,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689b30fa2b188c967287b834"
      },
      {
        "id": 1,
        "process_name": "Sweden 90 Days Business Single Entry Sticker visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11000,
        "service_charge": 1500,
        "visa_fees_agent": 11000,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689ca170bbe886337fa87859"
      }
    ],
    "country_name": "Sweden",
    "code": "SE",
    "hero_image_url": "https://images.unsplash.com/photo-1497217968520-7d8d60b7bc25?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8U3dlZGVufGVufDB8fDB8fHww",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c2d43b67b5d90d71e20",
    "name": "Sweden",
    "price": 11000,
    "price_agent": 11000,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/SE/1755095792020-stockholm-old-town-gamla-stan-1680860369-785X440.jpg",
      "https://cdn.tryvisa.com/Photos/SE/1755095801519-sweden-stockholm-city-hall-from-the-water.jpg"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 89
  },
  CH: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [
      {
        "id": 0,
        "process_name": "Switzerland Tourist Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11500,
        "service_charge": 1500,
        "visa_fees_agent": 11500,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689b3088bbe886337fa82bff"
      },
      {
        "id": 1,
        "process_name": "Switzerland Business Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 20,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "90 days",
        "entry_validity": "180 days",
        "visa_fees": 11500,
        "service_charge": 1500,
        "visa_fees_agent": 11500,
        "service_charge_agent": 1000,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689ca34cbbe886337fa87a2a"
      }
    ],
    "country_name": "Switzerland",
    "code": "CH",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/CH/1755096210118-unnamed.png",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c1343b67b5d90d71dc2",
    "name": "Switzerland",
    "price": 11500,
    "price_agent": 11500,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/CH/1755096216529-TAL-interlaken-PLACESSWITZERLAND1023-63826dadec0c4b8fba568018429ec120.jpg",
      "https://cdn.tryvisa.com/Photos/CH/1755096261936-43fee75dae5cc0d76aceb054742ee661.jpg"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 82
  },
  TW: {
    "priority": 10000,
    "isSchengen": true,
    "packages": [
      {
        "id": 0,
        "process_name": "Taiwan Tourist Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 15,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 5000,
        "service_charge": 1000,
        "visa_fees_agent": 5000,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 500,
        "zoneB": 600,
        "zoneC": 700,
        "_id": "689b3035bbe886337fa82b0d"
      },
      {
        "id": 1,
        "process_name": "Taiwan Business Sticker Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 15,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 5000,
        "service_charge": 1000,
        "visa_fees_agent": 5000,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "689ca630bbe886337fa87d33"
      }
    ],
    "country_name": "Taiwan",
    "code": "TW",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/TW/1755167064466-taiwan-klein-aber-wow-1684314919.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c0d43b67b5d90d71dab",
    "name": "Taiwan",
    "price": 5000,
    "price_agent": 5000,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/TW/1755096920807-98.jpg",
      "https://cdn.tryvisa.com/Photos/TW/1755096920811-Taiwan.jpg"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 87
  },
  TJ: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Tajikistan 30 Days Single Entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 2593,
        "service_charge": 1000,
        "visa_fees_agent": 2593,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687f692464508a5348a10f74"
      },
      {
        "id": 1,
        "process_name": "Tajikistan 30 Days Multiple Entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 5,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 4320,
        "service_charge": 1000,
        "visa_fees_agent": 4320,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687f692464508a5348a10f75"
      }
    ],
    "country_name": "Tajikistan",
    "code": "TJ",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/TJ/1753180814508-Iskanderkul-Lake-Tajikistan-Fann-Mountains-3-1024x768.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c2f43b67b5d90d71e29",
    "name": "Tajikistan",
    "price": 2593,
    "price_agent": 2593,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/TJ/1753180445796-Navruz_Palace-_TJ.jpg",
      "https://cdn.tryvisa.com/Photos/TJ/1753180445797-Statue_to_Ismoil_Somoni-_TJ.jpg"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 99
  },
  TZ: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Tanzania",
    "code": "TZ",
    "hero_image_url": "https://images.unsplash.com/photo-1589177900326-900782f88a55?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8VGFuemFuaWF8ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c3043b67b5d90d71e2c",
    "name": "Tanzania",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1589177900326-900782f88a55?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8VGFuemFuaWF8ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1589177900326-900782f88a55?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8VGFuemFuaWF8ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 99
  },
  TT: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Trinidad & Tobago",
    "code": "TT",
    "hero_image_url": "https://images.unsplash.com/photo-1607642875704-821b6eb0ba44?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8VHJpbmlkYWQlMjAlMjYlMjBUb2JhZ298ZW58MHx8MHx8fDA%3D",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c5243b67b5d90d71ea8",
    "name": "Trinidad & Tobago",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1607642875704-821b6eb0ba44?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8VHJpbmlkYWQlMjAlMjYlMjBUb2JhZ298ZW58MHx8MHx8fDA%3D",
      "https://images.unsplash.com/photo-1607642875704-821b6eb0ba44?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8VHJpbmlkYWQlMjAlMjYlMjBUb2JhZ298ZW58MHx8MHx8fDA%3D"
    ],
    "sticker_visa": false,
    "purpose": "visa_free",
    "visa_free_message": "",
    "__v": 0
  },
  UG: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [],
    "country_name": "Uganda",
    "code": "UG",
    "hero_image_url": "https://images.unsplash.com/photo-1581918629062-2b6cfdd04060?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8VWdhbmRhfGVufDB8fDB8fHww",
    "process": "digital",
    "supported": false,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c3443b67b5d90d71e3c",
    "name": "Uganda",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://images.unsplash.com/photo-1581918629062-2b6cfdd04060?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8VWdhbmRhfGVufDB8fDB8fHww",
      "https://images.unsplash.com/photo-1581918629062-2b6cfdd04060?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8VWdhbmRhfGVufDB8fDB8fHww"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0
  },
  GB: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "UK 6 Month Multiple Entry Stamp Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 30,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 Days",
        "entry_validity": "180 days",
        "visa_fees": 17796,
        "service_charge": 1000,
        "visa_fees_agent": 17796,
        "service_charge_agent": 500,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": false,
        "isPassportSubmissionAtEmbassy": true,
        "zoneA": 0,
        "zoneB": 0,
        "zoneC": 0,
        "_id": "68679c1e43b67b5d90d71de9"
      }
    ],
    "country_name": "United Kingdom",
    "code": "GB",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/GB/1.webp?v=2",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c1e43b67b5d90d71de8",
    "name": "United Kingdom",
    "price": 17796,
    "price_agent": 17796,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/GB/2.webp?v=2",
      "https://cdn.tryvisa.com/Photos/GB/3.webp?v=2"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 75
  },
  UY: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Uruguay Tourist- Multiple Entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 30,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 0,
        "service_charge": 1000,
        "visa_fees_agent": 0,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "Sticker Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 500,
        "zoneB": 600,
        "zoneC": 700,
        "_id": "689b2e2fbbe886337fa829e1"
      },
      {
        "id": 1,
        "process_name": "Uruguay Business - Multiple Entry",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 30,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "90 days",
        "visa_fees": 0,
        "service_charge": 1000,
        "visa_fees_agent": 0,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "Sticker Visa",
        "isDelivery": true,
        "isPassportSubmissionAtEmbassy": false,
        "isChildPackage": false,
        "child_visa_fees": 0,
        "child_visa_fees_agent": 0,
        "zoneA": 500,
        "zoneB": 600,
        "zoneC": 700,
        "_id": "689ca84abbe886337fa880be"
      }
    ],
    "country_name": "Uruguay",
    "code": "UY",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/UY/1755097387922-Uruguay-Scuplt-RSZ.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c3243b67b5d90d71e33",
    "name": "Uruguay",
    "price": 0,
    "price_agent": 0,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/UY/1755097395455-unnamed.png",
      "https://cdn.tryvisa.com/Photos/UY/1755097395458-uruguay-top-attractions-explore-montevideo.jpg"
    ],
    "sticker_visa": true,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 88
  },
  ZW: {
    "priority": 10000,
    "isSchengen": false,
    "packages": [
      {
        "id": 0,
        "process_name": "Zimbabwe 30 Days E- Visa Single",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 7,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 2595,
        "service_charge": 1000,
        "visa_fees_agent": 2595,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687f6c7364508a5348a11cff"
      },
      {
        "id": 1,
        "process_name": "Zimbabwe 30 Days E- Visa Multiple",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 8,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 3890,
        "service_charge": 1000,
        "visa_fees_agent": 3890,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Tourist",
        "visa_process": "E-Visa",
        "_id": "687f6c7364508a5348a11d00"
      },
      {
        "id": 2,
        "process_name": "Zimbabwe 30 Days Single Entry Business Visa E- Visa ",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 7,
        "eta_post_checkout_unit": "days",
        "entry_type": "Single Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 3890,
        "service_charge": 1000,
        "visa_fees_agent": 3890,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "6880d6f6310d4a59431aedbc"
      },
      {
        "id": 3,
        "process_name": "Zimbabwe 30 Days Multiple Business Visa E- Visa",
        "supported": true,
        "message": null,
        "eta_post_checkout_duration": 8,
        "eta_post_checkout_unit": "days",
        "entry_type": "Multiple Entry",
        "entry_length_stay": "30 days",
        "entry_validity": "60 days",
        "visa_fees": 3890,
        "service_charge": 1000,
        "visa_fees_agent": 3890,
        "service_charge_agent": 300,
        "speed": "regular",
        "visa_type": "Business",
        "visa_process": "E-Visa",
        "_id": "6880d6f6310d4a59431aedbd"
      }
    ],
    "country_name": "Zimbabwe",
    "code": "ZW",
    "hero_image_url": "https://cdn.tryvisa.com/Photos/ZW/1753181627733-GettyImages-143922110-5bf7964146e0fb0026a2df41.jpg",
    "process": "digital",
    "supported": true,
    "eta_pre_travel_duration": 45,
    "eta_pre_travel_unit": "days",
    "entry_documents": [],
    "additional_questions": [],
    "_id": "68679c3543b67b5d90d71e3f",
    "name": "Zimbabwe",
    "price": 2595,
    "price_agent": 2595,
    "extra_image_url": [
      "https://cdn.tryvisa.com/Photos/ZW/1753181635350-istockphoto-478724418-612x612.jpg",
      "https://cdn.tryvisa.com/Photos/ZW/1753181646489-zim.jpg"
    ],
    "sticker_visa": false,
    "purpose": "tourism",
    "visa_free_message": "",
    "__v": 0,
    "successRate": 100
  }
};